import { IconButton, List, ListItem, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { ChangedTask } from "routes/asset-register/plugins/general-tailoring/changed-task"
import { Accordion } from "minimals-template/components/accordion"
import { useEffect, useState } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { createSlot } from "lib/@components/slot/create-slot"
import { prevent } from "lib/prevent"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"
import { getWhere, parentTreeItem } from "library/tree"
import { If } from "lib/@components/switch"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export const TailoredScheduleAccordionAdditional = createSlot("TailoredScheduleAccordionAdditional")
export const TailoredScheduleWrapper = createSlot("TailoredScheduleWrapper")

export function TailoredSchedule({ item, last }) {
    const { filters, regimeId } = useBoundContext()
    const [open, setOpen] = useState(filters.length)
    const index = useTreeItemIndex()
    const location = getLocation(item.locations?.[0])
    const locationBreadcrumbLabel = getLocationBreadcrumbLabel(location, item.assets)

    useEffect(() => {
        setOpen(filters.length)
    }, [filters.length])

    return (
        <Bound tailoredItem={item}>
            <TailoredScheduleWrapper.Wrapper>
                <ListItem divider={!last} data-cy="tailored-schedule-list-item">
                    <Stack sx={{ width: 1 }}>
                        <ListItemBox>
                            <Stack sx={{ flex: 1, width: "100%" }}>
                                <Accordion
                                    titleSx={{ whiteSpace: "nowrap", ml: -2, minWidth: 0 }}
                                    sx={{ alignSelf: "flex-start" }}
                                    open={open}
                                    onChange={setOpen}
                                    title={
                                        <Typography
                                            variant="subtitle2"
                                            component="div"
                                            data-cy="tailored-schedule-item-title"
                                        >
                                            {item.scheduleTitle}{" "}
                                            <Typography component="span" variant="body2">
                                                #{item.code}
                                            </Typography>
                                        </Typography>
                                    }
                                    subTitle={
                                        <Stack spacing={0.5} sx={{ mt: 0.25 }}>
                                            <If value={locationBreadcrumbLabel}>
                                                <TruncatedTypography
                                                    variant="body2"
                                                    color="primary"
                                                    data-cy="tailored-schedule-location-breadcrumb"
                                                    sx={{
                                                        color: "primary.main",
                                                        minWidth: 0,
                                                        fontSize: 13,
                                                    }}
                                                >
                                                    {locationBreadcrumbLabel}
                                                </TruncatedTypography>
                                            </If>
                                            <Typography
                                                variant="body2"
                                                data-cy="tailored-schedule-tasks-accordion-title"
                                            >
                                                {item.changes.length} Tailored {"Task".pluralize(item.changes.length)}
                                            </Typography>
                                        </Stack>
                                    }
                                    data-cy={`tailored-schedule-accordion-${item.scheduleTitle}-${open ? "open" : "closed"}`}
                                    additional={
                                        <Stack direction="row" spacing={1}>
                                            <TailoredScheduleAccordionAdditional.Slot>
                                                <IconButton
                                                    aria-label="View schedule"
                                                    color="primary"
                                                    size="small"
                                                    onClick={prevent(handleView)}
                                                    data-cy="tailored-view-schedule"
                                                >
                                                    <Iconify icon="mdi:eye" />
                                                </IconButton>
                                            </TailoredScheduleAccordionAdditional.Slot>
                                        </Stack>
                                    }
                                >
                                    <List>
                                        <Repeat list={item.changes} item={<ChangedTask />} />
                                    </List>
                                </Accordion>
                            </Stack>
                        </ListItemBox>
                    </Stack>
                </ListItem>
            </TailoredScheduleWrapper.Wrapper>
        </Bound>
    )

    function handleView() {
        if (!location) return
        navigate(`/app/schedules/${location.id}${location.version ? `?version=${location.version}` : ""}`)
    }

    function getLocation(locationId) {
        if (!locationId) return null
        const [group, key] = locationId.split("!")
        return index.retrieve(`${group}~${regimeId}!${key}`)
    }

    function getLocationBreadcrumbLabel(location, assets) {
        if (!location?.[parentTreeItem]) return ""

        const locationLabel = getWhere(location[parentTreeItem])
        if (!assets) return locationLabel

        return `${assets} ${"Asset".pluralize(assets)} in ${locationLabel}`
    }
}
